
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, InputGroup, Row } from "react-bootstrap";
import './calculator.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalculator, faHexagonCheck, faSearch, faSpinner } from '@fortawesome/pro-solid-svg-icons';
import Dropdown from "react-bootstrap/Dropdown";
import FormControl from "react-bootstrap/FormControl";
import DatePicker from '../../../components/pickers/datePicker';
import { InputNumber } from "primereact/inputnumber";
import DataTableComponent from '../../../components/dataTables/dataTable';
import CalculatorLineChart from './chart/lineChart';
import moment from 'moment/moment';
import LiveTickerBar from '../../../components/live-ticker-bar/liveTickerBar';
import { useTranslation } from "react-i18next";
import { DashboardServiceApi, Configuration, QueryServiceApi } from "../../../../src/services/yieldcalculator";
import { APIControl } from '../../../helpers/APIControl';
import { useSelector } from 'react-redux';
import DateFormatter from '../../../formatters/DateFormatter';
import NumberFormatter from '../../../formatters/NumberFormatter';
import Spinner from '../../../components/spinner';

const Calculator = () => {
    const dashboardServiceApi = new DashboardServiceApi(new Configuration({ basePath: process.env.REACT_APP_YIELDCALCULATOR_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_YIELDCALCULATOR_API_BASE_PATH));
    const queryServiceApi = new QueryServiceApi(new Configuration({ basePath: process.env.REACT_APP_YIELDCALCULATOR_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_YIELDCALCULATOR_API_BASE_PATH));
    const token = useSelector((state) => state.auth?.token);
    const dateFormatter = new DateFormatter();
    const { t, i18n } = useTranslation();
    const language = i18n.language;

    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingBenchmarkPrice, setIsLoadingBenchmarkPrice] = useState(false);
    const [securitySelectItem, setSecuritySelectItem] = useState();
    const [selectedSecurityName, setSelectedSecurityName] = useState("DOĞUŞ OTOMOTİV");
    const [securityOptions, setSecurityOptions] = useState([]);
    const [securityOptionsSearchValue, setSecurityOptionsSearchValue] = useState("");
    const [benchmarkOptions, setBenchmarkOptions] = useState([]);
    const [benchmarkSelectedItem, setBenchmarkSelectedItem] = useState();
    const [selectedBenchmarkName, setSelectedBenchmarkName] = useState("BIST 30 NET");
    const [startingPrice, setStartingPrice] = useState(100000);
    const [startingQuantity, setStartingQuantity] = useState();
    const [startingBenchmarkValue, setStartingBenchmarkValue] = useState(0);
    const [endBenchmarkValue, setEndBenchmarkValue] = useState(0);
    const [firstDate, setFirstDate] = useState(moment().subtract(12, 'months').toDate());
    const [lastDate, setLastDate] = useState(new Date());
    const [table1Columns, setTable1Columns] = useState([]);
    const [table1Data, setTable1Data] = useState([]);
    const [table2Columns, setTable2Columns] = useState([]);
    const [table2Data, setTable2Data] = useState([]);
    const [table3Data, setTable3Data] = useState([]);
    const [lineChartData, setLineChartData] = useState([]);
    const numberFormatter = new NumberFormatter();
    const [filteredSecurityOptions, setFilteredSecurityOptions] = useState([]);
    const [endDividendPay, setEndDividendPay] = useState(0);
    const [hasFetchedData, setHasFetchedData] = useState(false);

    //#region DUMMY DATA

    const table1ColumnsData = [
        { id: 1, field: 'period', displayName: t('tableHeader.menstrualMovements'), header: t('tableHeader.menstrualMovements'), isVisible: true, width: '25%', align: 'left' },
        { id: 2, field: 'quantity', displayName: t('tableHeader.piece'), header: t('tableHeader.piece'), isVisible: true, width: '25%', align: 'right' },
        { id: 3, field: 'price', displayName: t('tableHeader.price'), header: t('tableHeader.price'), isVisible: true, width: '25%', align: 'right' },
        { id: 4, field: 'total', displayName: t('tableHeader.totalAmount'), header: t('tableHeader.totalAmount'), isVisible: true, width: '25%', align: 'right' },
    ];

    const table2ColumnsData = [
        { id: 1, field: 'item', displayName: t('tableHeader.returnByBenchmark'), header: t('tableHeader.returnByBenchmark'), isVisible: true, width: '30%', align: 'left' },
        { id: 2, field: 'income', displayName: '% ' + t('tableHeader.return') + ' TL', header: '% ' + t('tableHeader.return') + ' (TL)', isVisible: true, width: '35%', align: 'right' },
        { id: 3, field: 'incomeUSD', displayName: '% ' + t('tableHeader.return') + ' US($)', header: '% ' + t('tableHeader.return') + ' US ($)', isVisible: true, width: '35%', align: 'right' },
    ];

    const table3ColumnsData = [
        { id: 1, field: 'date', displayName: t('tableHeader.date'), header: t('tableHeader.date'), isVisible: true, width: '20%', align: 'left', sortable: true },
        { id: 2, field: 'desc', displayName: t('tableHeader.explanation'), header: t('tableHeader.explanation'), isVisible: true, width: '20%', align: 'left', sortable: true },
        { id: 3, field: 'ratio', displayName: t('tableHeader.ratio'), header: t('tableHeader.ratio'), isVisible: true, width: '20%', align: 'right', sortable: true },
        { id: 4, field: 'amount', displayName: t('tableHeader.amount'), header: t('tableHeader.amount'), isVisible: true, width: '20%', align: 'right', sortable: true },
        { id: 5, field: 'dividentYield', displayName: t('tableHeader.dividendYield-2'), header: t('tableHeader.dividendYield-2'), isVisible: true, width: '20%', align: 'right', sortable: true },
    ];



    const dummyChartdata = [
        {
            "date": 20190318,
            "value": 10.036222624016608,
            "hasValue": true
        },
        {
            "date": 20190319,
            "value": 10.48137765975928,
            "hasValue": true
        },
    ];

    //#endregion DUMMY DATA

    useEffect(() => {
        setTable1Columns(table1ColumnsData);
        setTable1Data([]);
        setTable2Columns(table2ColumnsData);
        setTable2Data([]);

        setTable3Data([]);

        let formattedDates = dummyChartdata.map(item => {
            return {
                ...item,
                date: new Date(moment(String(item.date), "YYYYMMDD")).getTime() // 'date' özelliğini formatla
            };
        });
        setLineChartData(formattedDates);
    }, []);

    useEffect(() => {
        getSharesSecurityOptions();
        getSharesBenchmarkOptions();
    }, []);

    useEffect(() => {
        setFilteredSecurityOptions(securityOptions);
    }, [securityOptions]);
    useEffect(() => {
        const fetchInitialData = async () => {
            try {

                if (benchmarkSelectedItem?.entityId) {
                    fetchBenchmarkPrice();

                }
            } catch (error) {
                console.error("Error fetching initial data:", error);
            }
        };

        fetchInitialData();
    }, [benchmarkSelectedItem, firstDate, lastDate]);


    useEffect(() => {
        const fetchInitialData = async () => {
            
            if (securitySelectItem?.entityId && benchmarkSelectedItem?.entityId && !hasFetchedData) {
                setIsLoading(true);
                await fetchData();
                setHasFetchedData(true); // Ensure this block only runs once
            }
        };
        fetchInitialData();
    }, [securitySelectItem, benchmarkSelectedItem]); // Dependency array watches for these variables


    //#region Dropdown İşlemleri

    const changeSecurityValue = (item) => {
        setSecuritySelectItem(item);
        setSelectedSecurityName(item.Name);
        setSecurityOptionsSearchValue("");
        setSecurityOptions(securityOptions);
    };

    const handleSearchChange = (e) => {
        const searchValue = e.target.value.toLowerCase();
        setSecurityOptionsSearchValue(searchValue);

        // Güvenlik seçeneklerini filtrele
        const filteredOptions = securityOptions.filter(option =>
            option.Name.toLowerCase().includes(searchValue) ||
            option.Code.toLowerCase().includes(searchValue)
        );
        setFilteredSecurityOptions(filteredOptions);
    };
    const changeBenchmarkValue = (item) => {
        setBenchmarkSelectedItem(item);
        setSelectedBenchmarkName(item.Name);
    };

    //#endregion Dropdown İşlemleri

    //#region Date Picker İşlemleri

    const selectedFirstDate = (date) => {
        setFirstDate(date);
    };

    const selectedLastDate = (date) => {
        setLastDate(date);
    };




    //#endregion Date Picker İşlemleri

    //#region Input İşlemleri

    const startingPriceChange = (value) => {
        setStartingPrice(value);
    };

    const startingQuantityChange = (value) => {
        setStartingQuantity(value);
    };

    const startingBenchmarkValueChange = (value) => {
        setStartingBenchmarkValue(value);
    };

    const endBenchmarkValueChange = (value) => {
        setEndBenchmarkValue(value);
    };

    //#endregion Input İşlemleri

    const calculateButton = () => {
        setIsLoading(true); // Loading başlatılır
        fetchData();
    };

    //#region SERVICE API CALL 

    const getSharesSecurityOptions = async () => {
        try {
            const culture = language;
            const response = await dashboardServiceApi.yieldcalculatorSharesGet(token, culture);
            if (response.data && response.data.items) {
                const formattedSecurityOptions = response.data.items
                    .map(item => ({
                        Code: item.code,
                        Name: item.name,
                        entityId: item.entityId
                    }))
                    .sort((a, b) => a.Name.localeCompare(b.Name)); // Sort alphabetically by Name


                // Find the index of the item with code "EREGLI"
                
                const defaultIndex = formattedSecurityOptions.findIndex(item => item.Code === 'THYAO');
                const selectedIndex = defaultIndex !== -1 ? defaultIndex : 0;

                // Set the found item or the first item as default
                setSecurityOptions(formattedSecurityOptions);
                setSecuritySelectItem(formattedSecurityOptions[selectedIndex]);
                setSelectedSecurityName(formattedSecurityOptions[selectedIndex].Name);
            }
        } catch (error) {
            console.log("getSharesSecurityOptions error: ", error);
        }
    };



    const getSharesBenchmarkOptions = async () => {
        try {
            const culture = language;
            const response = await dashboardServiceApi.yieldcalculatorBenchmarksGet(token, culture);
            if (response.data && response.data.items) {
                const formattedBenchmarkOptions = response.data.items
                    .map(item => ({
                        entityId: item.entityId,  // Using 'entityId' instead of 'id'
                        UniqueCode: item.code,    // Assuming 'code' is correct
                        Name: item.name
                    }))
                    .sort((a, b) => a.Name.localeCompare(b.Name)); // Sort alphabetically by Name

                setBenchmarkOptions(formattedBenchmarkOptions);

                // Find the index of the item with code "XU030"
                const defaultIndex = formattedBenchmarkOptions.findIndex(item => item.UniqueCode === 'XU030');
                const selectedIndex = defaultIndex !== -1 ? defaultIndex : 0;

                // Set the found item or the first item as default
                setBenchmarkSelectedItem(formattedBenchmarkOptions[selectedIndex]);
                setSelectedBenchmarkName(formattedBenchmarkOptions[selectedIndex].Name);
            }
        } catch (error) {
            console.log("getSharesBenchmarkOptions error: ", error);
        }
    };


    const fetchData = () => {
        try {
            const culture = language;
            const securityEntityId = securitySelectItem?.entityId;
            const benchmarkEntityId = benchmarkSelectedItem?.entityId;
            const startDate = dateFormatter.dateToInt(firstDate);
            const endDate = dateFormatter.dateToInt(lastDate);
            const investment = startingPrice;
            const numberOfShares = startingQuantity;

            queryServiceApi.queryFetchDataGet(token, securityEntityId, benchmarkEntityId, startDate, endDate, investment, numberOfShares, culture)
                .then((response) => {
                    if (response.data) {
                        const returnTableData = response.data.returnTable;

                        const updatedTable2Data = [
                            {
                                item: securitySelectItem?.Name,
                                income: numberFormatter.Double(returnTableData.securityTL, 2),
                                incomeUSD: numberFormatter.Double(returnTableData.securityUSD, 2)
                            },
                            {
                                item: selectedBenchmarkName,
                                income: numberFormatter.Double(returnTableData.benchmarkTRL, 2),
                                incomeUSD: numberFormatter.Double(returnTableData.benchmarkUSD, 2)
                            }
                        ];
                        setTable2Data(updatedTable2Data);

                        const numberOfSharesTable = response.data.numberOfSharesTable;
                        setEndDividendPay(numberFormatter.Double(numberOfSharesTable.endDividendPay, 2));
                        console.log('endDividendPay:', endDividendPay);
                        const updatedTable1Data = [
                            {
                                period: t('beginningfTerm'),
                                quantity: numberFormatter.Double(numberOfSharesTable.startUnit, 0),
                                price: numberFormatter.Double(numberOfSharesTable.startPrice, 2),
                                total: numberFormatter.Double(numberOfSharesTable.startTotalAmount, 2)
                            },
                            {
                                period: t('endOfTerm'),
                                quantity: numberFormatter.Double(numberOfSharesTable.endUnit, 0),
                                price: numberFormatter.Double(numberOfSharesTable.endPrice, 2),
                                total: numberFormatter.Double(numberOfSharesTable.endTotalAmount, 2)
                            }
                        ];
                        debugger;
                        setTable1Data(updatedTable1Data);

                        const capitalMovementTable = response.data.capitalMovementTable;
                        const updatedTable3Data = capitalMovementTable.map(item => ({
                            date: dateFormatter.intToDate(item.date),
                            desc: item.description,
                            ratio: `% ${numberFormatter.Double(item.ratio, 2)}`,
                            amount: numberFormatter.Double(item.amount, 2),
                            dividentYield: `% ${numberFormatter.Double(item.dividendYield, 2)}`
                        }));
                        setTable3Data(updatedTable3Data);

                        const chartData = response.data.chartItems.map(item => ({
                            date: dateFormatter.intToTimestampChartFormat(item.date),
                            securityValue: item.securityValue,
                            benchmarkValue: item.benchmarkValue
                        }));
                        setLineChartData(chartData);

                        console.log('Fetch Data Response:', response.data);
                    }
                })
                .finally(() => {
                    setIsLoading(false); // Veri çekme tamamlanınca loading kapatılır
                })
                .catch((error) => {
                    console.error("fetchData error:", error);
                    setIsLoading(false); // Hata durumunda loading kapatılır
                });
        } catch (error) {
            console.log("fetchData error: ", error);
            setIsLoading(false); // Hata durumunda loading kapatılır
        }
    };

    const fetchBenchmarkPrice = () => {
        try {
            const culture = language;
            setIsLoadingBenchmarkPrice(true); // Start loading
            queryServiceApi.queryFetchBenchmarkpriceGet(token, benchmarkSelectedItem?.entityId, dateFormatter.dateToInt(firstDate), dateFormatter.dateToInt(lastDate)).then((response) => {
                if (response.data) {
                    setStartingBenchmarkValue(numberFormatter.Double(response.data.starPrice, 2));
                    setEndBenchmarkValue(numberFormatter.Double(response.data.endPrice, 2));
                }
            })
                .finally(() => {
                    setIsLoadingBenchmarkPrice(false);
                });
        } catch (error) {
            console.log("fetchBenchmarkPrice error: ", error);
            setIsLoadingBenchmarkPrice(false);
        }
    };

    //#endregion SERVICE API CALL

    return (
        <div className='dividend-calculator-page'>
            <Row>
                <LiveTickerBar />
            </Row>

            <Container>
                <Row>
                    <Col>
                        <label className='page-name-title'>
                            {t('dividend.dividendCalculator.title')}
                        </label>
                    </Col>
                </Row>
            </Container>

            <Container>
                <Row>
                    <Col lg='3' md='4'>
                        <label className="input-label"> {t('dividend.dividendCalculator.stock')}</label>
                        <Dropdown data-bs-theme="dark" id="source-dropdown" className="custom-dropdown">
                            <Dropdown.Toggle variant="secondary">
                                <span className="item-name">{securitySelectItem && securitySelectItem.Name}</span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <InputGroup className="dropdown-search-input-group mx-auto m-b-5 p-l-10 p-r-10">
                                    <InputGroup.Text id="inputGroup-sizing-default">
                                        <FontAwesomeIcon icon={faSearch} />
                                    </InputGroup.Text>
                                    <FormControl
                                        type="text"
                                        placeholder={t('seachSymbol')}
                                        onChange={handleSearchChange}
                                        className="dropdownSearch"
                                        value={securityOptionsSearchValue}
                                    />
                                </InputGroup>
                                <div className="dropdown-scroll-menu">
                                    {filteredSecurityOptions.map((item, index) => (
                                        <Dropdown.Item
                                            key={index}
                                            onClick={() => changeSecurityValue(item)}
                                            className={item.Code === securitySelectItem?.Code ? "comboActiveItem" : ""}
                                        >
                                            <span className="item-name">{item.Name}</span>
                                            <FontAwesomeIcon icon={faHexagonCheck} className="fa-check" />
                                        </Dropdown.Item>
                                    ))}
                                </div>
                            </Dropdown.Menu>
                        </Dropdown>



                    </Col>

                    <Col md='2'>
                        <label className="input-label"> {t('startDate')}</label>
                        <DatePicker date={firstDate} selectedDate={selectedFirstDate} />
                    </Col>

                    <Col md='2'>
                        <label className="input-label"> {t('endDate')}</label>
                        <DatePicker date={lastDate} selectedDate={selectedLastDate} />
                    </Col>

                    <Col md='2' className='initial-investment-input-col'>
                        <label className="input-label"> {t('dividend.dividendCalculator.initialInvestment')} </label>
                        <InputNumber
                            className='initial-investment-input'
                            value={startingPrice}
                            onChange={(e) => startingPriceChange(e.value)}
                            style={{ width: '100%' }}
                            placeholder={t('enterValue')}
                        />
                    </Col>

                    <Col md='1' className='veya-label-col'>
                        <label className="input-label"> {t('or')}</label>
                    </Col>

                    <Col md='2' className='initial-piece-input-col'>
                        <label className="input-label">{t('dividend.dividendCalculator.initialQuantity')} </label>
                        <InputNumber
                            value={startingQuantity}
                            onChange={(e) => startingQuantityChange(e.value)}
                            style={{ width: '100%' }}
                            placeholder={t('enterValue')}
                        />
                    </Col>
                </Row>

                <Row className='row-second-options'>
                    <Col md='3'>
                        <label className="input-label"> {t('dividend.dividendCalculator.benchmark')}</label>
                        <Dropdown data-bs-theme="dark" id="source-dropdown" className="custom-dropdown">
                            <Dropdown.Toggle variant="secondary">{benchmarkSelectedItem && benchmarkSelectedItem.Name}</Dropdown.Toggle>
                            <Dropdown.Menu>
                                <div className="dropdown-scroll-menu">
                                    {benchmarkOptions.map((item, index) => (
                                        <Dropdown.Item key={index} onClick={() => changeBenchmarkValue(item)} className={item.UniqueCode === benchmarkSelectedItem?.UniqueCode ? "comboActiveItem" : ""}>
                                            {item.Name}
                                            <FontAwesomeIcon icon={faHexagonCheck} />
                                        </Dropdown.Item>
                                    ))}
                                </div>
                            </Dropdown.Menu>
                        </Dropdown>
                    </Col>

                    <Col md='2' className="p-field p-col-12">
                        <label className="input-label"> {t('dividend.dividendCalculator.initialValueOfBenchmark')}</label>
                        <div className="p-inputgroup benchmark-inputs">
                            {isLoadingBenchmarkPrice ? (
                                <FontAwesomeIcon icon={faSpinner} pulse style={{ width: '100%', display: 'block', alignContent: 'center', alignItems: 'center', alignSelf: 'center' }} />
                            ) : (
                                <label className="benchmark-title">{selectedBenchmarkName} : {startingBenchmarkValue}</label>
                            )}
                        </div>
                    </Col>

                    <Col md='2'>
                        <label className="input-label"> {t('dividend.dividendCalculator.endValueOfBenchmark')}</label>
                        <div className="p-inputgroup benchmark-inputs">
                            {isLoadingBenchmarkPrice ? (
                                <FontAwesomeIcon icon={faSpinner} pulse style={{ width: '100%', display: 'block', alignContent: 'center', alignItems: 'center', alignSelf: 'center' }} />
                            ) : (
                                <label className="benchmark-title">{selectedBenchmarkName} : {endBenchmarkValue}</label>
                            )}
                        </div>
                    </Col>


                    <Col md='5'>
                        <label className="input-label button">{t('dividend.dividendCalculator.calculateLowercase')}</label>
                        <Button className="button apply roboto-bold-16" onClick={calculateButton}>
                            <label className='icon'>
                                <FontAwesomeIcon icon={faCalculator} />
                                <span className='button-text'> {t('dividend.dividendCalculator.calculateUppercase')}  </span>
                            </label>
                        </Button>
                    </Col>
                </Row>
            </Container>


            {isLoading ? (
                <div style={{ height: '50vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Spinner />  {/* Loading durumu varsa spinner gösterilir */}
                </div>) : (
                <>
                    <Container>
                        <Row className='table-row-1'>
                            <Col md={6}>
                                <DataTableComponent columnsProp={table1Columns} dataProp={table1Data} columnsSelect={false} search={false} absoluteSearch={false} />
                                <label className='return-desc-text'>
                                    {endDividendPay == '' ? '-' : endDividendPay} {t('reinvested')}
                                </label>
                            </Col>

                            <Col md={6}>
                                <DataTableComponent columnsProp={table2Columns} dataProp={table2Data} columnsSelect={false} search={false} absoluteSearch={false} />
                            </Col>
                        </Row>
                    </Container>

                    <Container>
                        <Row>
                            <Col className='page-middle-title-col'>
                                <label className='title'>
                                    {t('dividend.dividendCalculator.capitalMovements')}
                                </label>
                            </Col>
                        </Row>
                    </Container>

                    <Container>
                        <Row>
                            <Col md={12}>
                                <DataTableComponent columnsProp={table3ColumnsData} dataProp={table3Data} columnsSelect={false} search={false} absoluteSearch={false} scrollHeight={300} />
                            </Col>
                        </Row>
                    </Container>

                    <Container className='chart-container mt-5'>
                        <Row>
                            <Col>
                                <CalculatorLineChart data={lineChartData} averageValue={10} selectedSecurity={selectedSecurityName} divId="unique-calculator-chart" />
                            </Col>
                        </Row>
                    </Container>
                </>
            )}
        </div>
    );

};

export default Calculator;
